module.exports = __webpack_public_path__ + "static/img/qyfljc-ngsc1.c94bd2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qyfljc-ngsc1.png
// module id = AVYO
// module chunks = 0